import styled, { css } from 'styled-components';

const ShopCartDetail = styled.div`
  display: flex;
  flex-direction: row;
  box-sizing: border-box;
  align-items: flex-start;
  width: 100%;
  background: ${({ theme }) => theme.commons.card.background};
  padding-bottom: ${({ theme }) => theme.spacing(6)};
  ${({ isCart, theme }) =>
    isCart &&
    css`
      box-shadow: ${theme.commons.card.elevation};
      padding: ${theme.spacing(4, 8, 6, 8)};
    `}

  img {
    width: 38px;
    height: 38px;
    border: solid 1px ${({ theme }) => theme.colors.textSecondary};
    border-radius: 5px;
  }
`;

export default ShopCartDetail;
